let store;

export const setStore = (configuredStore) => {
  store = configuredStore;
};

export const getStore = () => {
  if (!store) {
    throw new Error("Redux store has not been initialized yet.");
  }

  return store;
};
